import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserDetail } from '@classes/user-detail';
import { Role } from '@enums/role.enum';
import { UiService } from 'app/core/services/ui.service';
import { UserDetailComponent } from '../../components/user-detail/user-detail.component';
import { UsersGridComponent } from '../../components/users-grid/users-grid.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  Role = Role;

  @ViewChild('UsersGridComponent') usersGridComponent: UsersGridComponent;

  constructor(
    public dialog: MatDialog,
    public uiService: UiService
  ) { }

  ngOnInit() {
  }

  createUser() {
    const data = new UserDetail({
      isCreationMode: true
    });
    const dialogRef = this.dialog.open(UserDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.usersGridComponent.getUsers();
        this.uiService.displayMessageToast('user.success-edit');
      }
    })
  }
}
